<template>
	<div class="payment-table-report">
		<div class="table-block margin-bottom-medium" v-for="(items, index) in tableData" :key="index">
						<div class="payment-table-report__header table-block-header margin-bottom">
				<h3>{{ getUserName(index) }}</h3>
				<dl class="bg-gray-100">
					<dt>Сумма по сделкам:</dt><dd>{{ getSumAmount(items) }} руб.</dd>
					<dt>Сумма по процентам:</dt><dd>{{ getSumAmount(items, true) }} руб.</dd>
					<template v-if="type > 0"><dt>Личный вклад по сделкам:</dt><dd>{{ getContribSum(items) }} руб.</dd></template>
				</dl>
			</div>

			<vuetable ref="vuetable"
				:fields="columns"
				:api-mode="false"
				:data="items"
				@vuetable:row-dblclicked="rowClickHandler"
				class="table-striped"
				noDataTemplate="Ничего не найдено">
				<template slot="product_type" slot-scope="props">
					<b-badge variant="primary">
						{{ props.rowData.product_type.name }}
					</b-badge>
				</template>
				<template slot="b24_id" slot-scope="props">
					<a :href="'https://legalbis.bitrix24.ru/crm/deal/details/' + props.rowData.b24_id + '/'" target="_blank">{{ props.rowData.b24_id }}</a>
				</template>
				<template slot="amount" slot-scope="props">
					{{ props.rowData.amount | currency}}
				</template>
				<template slot="contrib" slot-scope="props">
					{{ props.rowData.amount / props.rowData.index | currency}}
				</template>
				<template slot="percent" slot-scope="props">
					{{ (props.rowData.percent / props.rowData.index).toFixed(2) }}
				</template>
				<template slot="result" slot-scope="props">
					<b-badge variant="success">
						{{ getResultSum(props.rowData.amount, props.rowData.percent / props.rowData.index) }}
					</b-badge>
				</template>
				<template slot="manager" slot-scope="props">
					{{ props.rowData.manager }}
				</template>
			</vuetable>
		</div>
	</div>
</template>
<script>
export default {
	data () {
		return {
			tableData: [],
			columns: [
				{
					name: 'id',
					title: '#'
				}, {
					name: 'counterparty',
					title: 'Контрагент'
				}, {
					name: 'product',
					title: 'Продукт'
				}, {
					name: '__slot:product_type',
					title: 'Тип продукта'
				}, {
					name: '__slot:b24_id',
					title: 'ID сделки Bitrix24'
				}, {
					name: '__slot:amount',
					title: 'Сумма'
				},
				{
					name: '__slot:contrib',
					title: 'Вклад'
				}, {
					name: '__slot:percent',
					title: 'Процент'
				}, {
					name: '__slot:result',
					title: 'Итог'
				}, {
					name: '__slot:manager',
					title: 'менеджер'
				}
			]
		}
	},
	props: {
		type: {
			type: Number,
			default: 0
		},
		dateStart: String,
		users: Object
	},
	mounted () {
		this.getData()
	},
	methods: {
		getData () {
			let type = this.type
			if (this.type === 0) type = 'manager'

			this.$store.commit('CALL_API_ON')
			this.$http.get(this.$store.state.apiURL + '/v1/payment/reports', {
				params: {
					type: type,
					date_start: this.dateStart
				}
			}, {
			}).then(function (response) {
				this.tableData = response.body
				this.$store.commit('CALL_API_OFF')
			}, function (response) {
			})
		},
		rowClickHandler (row, event) {
			this.$router.push({path: `/payments/details/${row.id}/update`})
		},
		getUserName (id) {
			if (Object.keys(this.$store.state.userModule.users).length === 0) return ''
			const user = this.$store.state.userModule.users[id]
			return user.first_name + ' ' + user.last_name
		},
		getResultSum (amount, percent) {
			let result = amount * (percent / 100)
			return this.$options.filters.currency(result)
		},
		getSumAmount (items, percent = false) {
			let result = 0
			// let percent = false
			items.forEach((value, key) => {
				if (percent === true && value.hasOwnProperty('percent') && value.percent > 0) {
					// percent = true
					result = result + value.amount * (value.percent / value.index / 100)
				} else {
					result = result + Number(value.amount)
				}
			})

			return this.$options.filters.currency(result)
		},
		getContribSum (items) {
			let result = 0
			items.forEach((value, key) => {
				if (value.hasOwnProperty('percent') && value.percent > 0) {
					result = result + value.amount / value.index
				} else {
					result = result + Number(value.amount)
				}
			})

			return this.$options.filters.currency(result)
		}
	},
	watch: {
		type: function (val) {
			this.getData()
		}
	}
}
</script>
<style lang="scss">
.table-block-header {
	font-weight: bold;
}
.payment-table-report {
	.payment-table-report__header {
		dl {
			padding: 0.75rem 1rem;
		}
		dt, dd {
			width: auto;
			padding: 0;
			margin: 0.15rem 0;
		}
		dt {
			float: left;
			clear: left;
			width: 160px;
			margin-right: 1rem;
			text-align: left;
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/components/payment/payment-report-table.vue